import alb from 'services/api/alb';

export interface PlanningTabsFilterRequest {
	page?: number;
	size?: number;
	company_area_id?: number;
	order?: [string, 'ASC' | 'DESC'][];
	hierarchy: string;
	level: string;
	filter_by_parent?: Array<{
		level: string;
		value: number | number[];
	}>;
	search?: string;
	cycle_id: number;
	filters_check: {
		product_ids: number[];
		commercial_hierarchy_ids: number[];
		customer_ids: number[];
	};
}

export interface PlanningTabsFilterResponse {
	count: number;
	rows: any[];
	quantityAllIds?: number;
	countNoTextSearch?: number;
	ids?: number[];
}

export const planningTabsFilterRequest = async (
	forecastType: string,
	params: PlanningTabsFilterRequest
): Promise<PlanningTabsFilterResponse> => {
	const response = await alb.post(`/${forecastType}/filter`, params);
	return response.data;
};

export const planningTabsFilterLabelsRequest = async (
	forecastType: string,
	params: PlanningTabsFilterRequest
): Promise<PlanningTabsFilterResponse> => {
	const response = await alb.post(`/${forecastType}/filter-labels`, params);
	return response.data;
};

export const planningTabsFilterCompletedRequest = async (
	forecastType: string,
	params: PlanningTabsFilterRequest
): Promise<PlanningTabsFilterResponse> => {
	const response = await alb.post(
		`/${forecastType}/filter-labels-completed`,
		params
	);
	return response.data;
};
